// The shape of the pipeline in one strip, and the stage filter in the same object:
// segment widths show where it is thick, and the chips below carry the counts —
// deliberately including stages with nothing in them, since an empty stage is
// exactly the gap worth seeing.
//
// Clicking a chip filters to that stage; clicking the active one clears it. The
// rail is the control because it already lists every stage with its count, so the
// screen needs no second row of stage buttons.
import he from '../../i18n/he';

export default function PipelineRail({ stages, counts, active, onSelect }) {
  return (
    <div className="pipeline-rail">
      {/* Decorative: the same numbers are readable as text below. */}
      <div className="rail-bar" aria-hidden="true">
        {stages.map((stage) => {
          const n = counts[stage] || 0;
          return (
            <div
              key={stage}
              data-stage={stage}
              className={[
                'rail-seg',
                n === 0 ? 'is-empty' : '',
                active && active !== stage ? 'is-dimmed' : '',
              ].filter(Boolean).join(' ')}
              // An empty stage keeps a sliver so the gap is visible rather than absent.
              style={{ flexGrow: n || 0.15 }}
            />
          );
        })}
      </div>
      <div className="rail-stages">
        {stages.map((stage) => {
          const n = counts[stage] || 0;
          return (
            <button
              key={stage}
              type="button"
              data-stage={stage}
              className={[
                'rail-stage',
                n === 0 ? 'is-empty' : '',
                active === stage ? 'is-active' : '',
              ].filter(Boolean).join(' ')}
              aria-pressed={active === stage}
              onClick={() => onSelect(active === stage ? null : stage)}
            >
              <span className="rail-dot" />
              <span className="rail-name">{he.leadStages[stage]}</span>
              <span className="rail-count">{n}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
